import { useEffect, useMemo } from 'react';
import debounce from 'lodash/debounce';
import { useIdentity } from '../../../hooks';
import { trackEvent } from '../../../utils/analytics';

/**
 * Debounced analytics for search keystrokes, cancelled on unmount so a
 * trailing call can't fire after the search box is gone.
 */
export function useSearchTracking(eventName: string, wait = 1000) {
  const identity = useIdentity() as any;
  const { tenant_id, login_email } = identity;

  const track = useMemo(
    () => debounce((searchTerm: string) => {
      if ('' !== searchTerm.trim()) {
        trackEvent(eventName, {
          tenant_id,
          login_email,
          search_term: searchTerm,
        });
      }
    }, wait),
    [eventName, wait, tenant_id, login_email]
  );

  useEffect(() => () => track.cancel(), [track]);

  return track;
}
